import { useOptionalWorkspaceTabsState } from 'features/workspaceTabs/contexts/WorkspaceTabsContext'
import { useRef } from 'react'

/**
 * The workspace tab this page mounted on. Plus creates and activates a new
 * tab before navigation, so effects that stamp the "active" tab must ignore
 * that successor until this page unmounts.
 */
export function useBoundWorkspaceTabId(): string | undefined {
  const state = useOptionalWorkspaceTabsState()
  const boundTabIdRef = useRef<string | undefined>(undefined)
  if (boundTabIdRef.current === undefined && state?.activeTabId) {
    boundTabIdRef.current = state.activeTabId
  }
  return boundTabIdRef.current
}
